import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Prevent the error from propagating to React's error overlay
        error.preventDefault?.();
        
        // You can log the error to an error reporting service here
        console.error('Error caught by boundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-page">
                    <h1>Oops! Don't know how we got here</h1>
                    <p>Something unexpected happened. Let's try refreshing the page.</p>
                    <button 
                        onClick={() => window.location.reload()}
                        className="refresh-button"
                    >
                        Refresh Page
                    </button>
                    <p>If the problem persists, please contact support. <a href="mailto:joshuaftmilner@gmail.com">joshuaftmilner@gmail.com</a></p>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary; 